"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = require("../image");
var mapInfoPage = function mapInfoPage(response) {
  var _response$data$seotit, _response$data$seodes;
  if (!response) return false;
  return {
    title: response.data.title[0].text,
    seoTitle: ((_response$data$seotit = response.data.seotitle) === null || _response$data$seotit === void 0 ? void 0 : _response$data$seotit.length) > 0 ? response.data.seotitle[0].text : false,
    seoDescription: ((_response$data$seodes = response.data.seodescription) === null || _response$data$seodes === void 0 ? void 0 : _response$data$seodes.length) > 0 ? response.data.seodescription[0].text : false,
    content: response.data.body.map(function (paragraph) {
      return {
        text: paragraph.primary.text
      };
    }),
    option: response.data.body.map(function (paragraph) {
      if (paragraph.slice_type === "option") {
        return paragraph.items[0];
      }
    }),
    image: response.data.body.map(function (paragraph) {
      if (paragraph.slice_type === "image") {
        if (paragraph.primary) {
          return response.type === "pro-infopage" ? (0, _image.mapRichImage)(paragraph.primary).image : paragraph.primary;
        }
      }
    })
  };
};
var _default = mapInfoPage;
exports["default"] = _default;